function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

if (window.location.pathname.includes('/collections/')) {
  var collectionData = JSON.stringify({ 
    name: window.collectionTitle || '', 
    handle: window.collectionHandle || '' 
  });
  setCookie('lastBrowsedCollection', collectionData, 7);
}

document.addEventListener('DOMContentLoaded', function() {
  const showMoreBtn = document.querySelector('.show-more.ab-test-element');
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function () {
      const menuList = document.querySelector('.collections-categories-menu__list');
      const button = this;
      
      if (menuList) {
        const isAtEnd = menuList.scrollLeft + menuList.clientWidth >= menuList.scrollWidth;

        if (isAtEnd) {
          menuList.scrollLeft -= 500;
          menuList.classList.remove('at-end');
          button.classList.remove('toggle-end');
        } else {
          menuList.scrollLeft += 500;
          const afterScrollAtEnd = menuList.scrollLeft + menuList.clientWidth >= menuList.scrollWidth;
          if (afterScrollAtEnd) {
            menuList.classList.add('at-end');
            button.classList.add('toggle-end');
          }
        }
      }
    });
  }
});

/**
 * Shared fetch-and-append logic used by both infinite scroll and load-more modes.
 *
 * state object shape:
 *   { isLoading: bool, loadedUrls: Set, currentNextPageUrl: string|null }
 *
 * onComplete(addedCount) is called after products are appended (or on error).
 */
function fetchAndAppendProducts(url, state, grid, onComplete) {
  if (state.isLoading || !url || state.loadedUrls.has(url)) {
    if (onComplete) onComplete(0);
    return;
  }

  state.isLoading = true;
  state.loadedUrls.add(url);

  fetch(url)
    .then(function(response) {
      if (!response.ok) {
        throw new Error('HTTP error! status: ' + response.status);
      }
      return response.text();
    })
    .then(function(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      let newProducts = doc.querySelectorAll('.infinite-scroll-grid .product-grid-item__wrapper, .infinite-scroll-grid .product-grid-item');

      if (newProducts.length === 0) {
        newProducts = doc.querySelectorAll('.collection-body-grid .product-grid-item__wrapper, .collection-body-grid .product-grid-item');
      }

      let addedCount = 0;

      if (newProducts.length > 0 && grid) {
        const existingProductIds = new Set();
        const existingProductHandles = new Set();
        const existingProductUrls = new Set();
        const existingProducts = grid.querySelectorAll('.product-grid-item__wrapper[data-product-id], .product-grid-item[data-product-id]');

        existingProducts.forEach(function(item) {
          const productId = item.getAttribute('data-product-id');
          const productHandle = item.getAttribute('data-product-handle');
          const productLink = item.querySelector('a[href]');
          const productUrl = productLink ? productLink.getAttribute('href') : null;

          if (productId) existingProductIds.add(productId);
          if (productHandle) existingProductHandles.add(productHandle);
          if (productUrl) existingProductUrls.add(productUrl);
        });

        newProducts.forEach(function(product) {
          const productId = product.getAttribute('data-product-id');
          const productHandle = product.getAttribute('data-product-handle');
          const productLink = product.querySelector('a[href]');
          const productUrl = productLink ? productLink.getAttribute('href') : null;

          if ((productId && existingProductIds.has(productId)) ||
              (productHandle && existingProductHandles.has(productHandle)) ||
              (productUrl && existingProductUrls.has(productUrl))) {
            return;
          }

          if (!productId) return;

          existingProductIds.add(productId);
          if (productHandle) existingProductHandles.add(productHandle);
          if (productUrl) existingProductUrls.add(productUrl);

          const clonedProduct = product.cloneNode(true);
          grid.appendChild(clonedProduct);

          const looxRating = clonedProduct.querySelector('.loox-rating');
          if (looxRating && window.Loox && window.Loox.loadRating) {
            window.Loox.loadRating(looxRating);
          }

          const atcButton = clonedProduct.querySelector('.product-grid-item__atc');
          if (atcButton) {
            const initEvent = new CustomEvent('initializeAjaxButton', {
              detail: { element: atcButton, productHandle: atcButton.getAttribute('data-product-handle') }
            });
            document.dispatchEvent(initEvent);

            if (window.initializeAjaxATC) window.initializeAjaxATC(atcButton);
            if (window.initAjaxButtons) window.initAjaxButtons(atcButton);
          }

          const event = new CustomEvent('productAdded', { detail: { product: clonedProduct } });
          document.dispatchEvent(event);

          addedCount++;
        });
      }

      // Resolve the next page URL from the fetched document.
      // Primary: the load-more button in the fetched page is server-rendered inside
      // {% paginate %} and only exists when paginate.next is truthy — the most
      // reliable signal available.
      let foundNextUrl = null;

      const nextLoadMoreBtn = doc.getElementById('load-more-btn');
      if (nextLoadMoreBtn) {
        foundNextUrl = nextLoadMoreBtn.getAttribute('data-next-url') || null;
      }

      // Fallback for infinite-scroll mode (no load-more button in the fetched HTML).
      if (!foundNextUrl) {
        const relNextLink = doc.querySelector('.pagination a[rel="next"]');
        if (relNextLink) foundNextUrl = relNextLink.href;
      }

      if (!foundNextUrl) {
        const currentPageMatch = url.match(/page=(\d+)/);
        const currentPage = currentPageMatch ? parseInt(currentPageMatch[1]) : 1;
        const nextPage = currentPage + 1;

        const allPageLinks = doc.querySelectorAll('.pagination-inner .page a[href*="page="]');
        let maxPage = currentPage;

        allPageLinks.forEach(function(link) {
          const pageMatch = link.href.match(/page=(\d+)/);
          if (pageMatch) {
            const pageNum = parseInt(pageMatch[1]);
            if (pageNum > maxPage) maxPage = pageNum;
            if (pageNum === nextPage && !foundNextUrl) foundNextUrl = link.href;
          }
        });

        if (!foundNextUrl && nextPage <= maxPage) {
          const nextLink = doc.querySelector('.pagination-inner .next a[href*="page=' + nextPage + '"]');
          if (nextLink) foundNextUrl = nextLink.href;
        }
      }

      state.currentNextPageUrl = foundNextUrl || null;
      state.isLoading = false;

      if (onComplete) onComplete(addedCount);
    })
    .catch(function() {
      state.isLoading = false;
      if (onComplete) onComplete(0);
    });
}

// ---------------------------------------------------------------------------
// Load More button mode
// Called when the merchant has enabled "Use Load More button" in section settings.
// ---------------------------------------------------------------------------
function initLoadMore(initialNextUrl) {
  const button = document.getElementById('load-more-btn');
  const container = document.getElementById('load-more-container');
  const grid = document.getElementById('infinite-scroll-container');

  if (!button || !grid) return;

  // Prefer the data attribute on the button (set server-side inside {% paginate %} where
  // paginate.next is guaranteed to be in scope). Fall back to the argument for edge cases.
  const startUrl = button.getAttribute('data-next-url') || initialNextUrl;
  if (!startUrl) return;

  const state = {
    isLoading: false,
    loadedUrls: new Set(),
    currentNextPageUrl: startUrl,
  };

  button.addEventListener('click', function() {
    if (state.isLoading || !state.currentNextPageUrl) return;

    const productSelector = '.product-grid-item__wrapper, .product-grid-item';
    const previousCount = grid.querySelectorAll(productSelector).length;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetchAndAppendProducts(state.currentNextPageUrl, state, grid, function(addedCount) {
      button.disabled = false;
      button.removeAttribute('aria-busy');

      // Move focus to the first focusable element in the first newly appended card
      if (addedCount > 0) {
        const allProducts = grid.querySelectorAll(productSelector);
        const firstNew = allProducts[previousCount];
        if (firstNew) {
          const focusTarget = firstNew.querySelector('a[href], button:not([disabled])');
          if (focusTarget) {
            focusTarget.focus();
          } else {
            firstNew.setAttribute('tabindex', '-1');
            firstNew.focus();
          }
        }
      }

      // No more pages — remove the button entirely so it isn't a dead control
      if (!state.currentNextPageUrl && container) {
        container.hidden = true;
      }
    });
  });
}

// ---------------------------------------------------------------------------
// Infinite scroll mode
// Called when the merchant has enabled "Enable infinite scroll" (and NOT load-more).
// ---------------------------------------------------------------------------
function initInfiniteScroll(enableInfiniteScroll, hasNextPage, nextPageUrl) {
  if (!enableInfiniteScroll || window.innerWidth <= 800) return;

  const grid = document.getElementById('infinite-scroll-container');

  const state = {
    isLoading: false,
    loadedUrls: new Set(),
    currentNextPageUrl: nextPageUrl,
  };

  let initialPagination = document.querySelector('.pagination a[rel="next"]');
  if (!initialPagination) {
    initialPagination = document.querySelector('.pagination .next, .pagination a[href*="page="]:last-child');
  }

  if (initialPagination && !state.currentNextPageUrl) {
    state.currentNextPageUrl = initialPagination.href;
  }

  let scrollTimeout;
  let lastScrollY = 0;

  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      if (state.isLoading || !state.currentNextPageUrl) return;

      if (window.scrollY <= lastScrollY) {
        lastScrollY = window.scrollY;
        return;
      }
      lastScrollY = window.scrollY;

      const scrollPosition = window.innerHeight + window.scrollY;
      const documentHeight = document.documentElement.offsetHeight;
      const threshold = 1000;
      const distanceFromBottom = documentHeight - scrollPosition;

      if (distanceFromBottom <= threshold) {
        fetchAndAppendProducts(state.currentNextPageUrl, state, grid, function(addedCount) {
          // After auto-load, check if we should load again immediately (user is still near the bottom)
          setTimeout(function() {
            const scrollPos = window.innerHeight + window.scrollY;
            const docHeight = document.documentElement.offsetHeight;
            if (docHeight - scrollPos <= threshold && state.currentNextPageUrl) {
              fetchAndAppendProducts(state.currentNextPageUrl, state, grid, null);
            }
          }, 200);
        });
      }
    }, 100);
  });
}
